import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';


// Acción asíncrona para obtener tickets por evento
export const fetchTicketsByEvent = createAsyncThunk('tickets/fetchTicketsByEvent',
    async ( slug, eventId, { rejectWithValue }) => {
        console.log('Fetching tickets for eventId:', eventId); // Asegúrate de que no sea undefined
        try {
            const response = await axios.get(`${slug}/api/tickets/event/${eventId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

// Acción asíncrona para obtener todos los tickets vendidos
export const fetchAllTickets = createAsyncThunk('tickets/fetchAllTickets',

    async ({ slug } , { rejectWithValue }) => {
        try {
            const response = await axios.get(`${slug}/api/tickets/`);
            console.log('response: ', response);

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

const ticketSlice = createSlice({
    name: 'tickets',
    initialState: {
        ticket: null,
        tickets: [],
        ticketsByEvent: [], // Para almacenar los tickets por evento
        loading: false,
        error: null,
    },
    reducers: {
        clearTicketState: (state) => {
            state.ticket = null;
            state.ticketsByEvent = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Manejar la obtención de tickets por evento
            .addCase(fetchTicketsByEvent.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTicketsByEvent.fulfilled, (state, action) => {
                state.ticketsByEvent = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchTicketsByEvent.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAllTickets.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllTickets.fulfilled, (state, action) => {
                state.tickets = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchAllTickets.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearTicketState } = ticketSlice.actions;
export default ticketSlice.reducer;
